import { FINDING_STYLE } from "@/lib/dental";

// Every finding carries a letter glyph as well as a colour, so the chart stays
// readable in a monochrome printout and for colour-vision-deficient readers.
export default function ChartLegend() {
  const shown = [
    "caries", "restoration", "crown", "root_canal",
    "sealant", "fracture", "missing", "implant",
  ];
  return (
    <div className="mt-4 pt-3 border-t border-slate-200" data-testid="chart-legend">
      <div className="flex flex-wrap gap-x-4 gap-y-2">
        {shown.map((k) => {
          const s = FINDING_STYLE[k];
          return (
            <div key={k} className="flex items-center gap-1.5">
              <span
                className="w-4 h-4 rounded-sm flex items-center justify-center text-[8px] font-bold shrink-0"
                style={{ background: s.fill, color: s.text, border: `1px solid ${s.stroke}` }}
              >
                {s.glyph}
              </span>
              <span className="text-[11px] text-slate-600">{s.label}</span>
            </div>
          );
        })}
        <div className="flex items-center gap-1.5">
          <span className="w-4 h-4 rounded-sm shrink-0 bg-white"
                style={{ border: "2.5px dashed #2563eb" }} />
          <span className="text-[11px] text-slate-600">Planned (hollow)</span>
        </div>
      </div>
    </div>
  );
}
